
import { defineComponent, PropType } from 'vue'
import { IconType } from '@/enums/IconType'
import { CDN_PREFIX_URI } from '@/constants/cdnPrefix'
export default defineComponent({
  name: 'Icon',
  props: {
    type: {
      type: String as PropType<IconType>,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      CDN_PREFIX_URI,
    }
  },
})
